import { render, staticRenderFns } from "./ListContasBancarias.vue?vue&type=template&id=5b702a3b"
import script from "./ListContasBancarias.vue?vue&type=script&lang=js"
export * from "./ListContasBancarias.vue?vue&type=script&lang=js"
import style0 from "./ListContasBancarias.vue?vue&type=style&index=0&id=5b702a3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports